import { render, staticRenderFns } from "./categoryCountPie.vue?vue&type=template&id=283baad9&"
import script from "./categoryCountPie.vue?vue&type=script&lang=js&"
export * from "./categoryCountPie.vue?vue&type=script&lang=js&"
import style0 from "./categoryCountPie.vue?vue&type=style&index=0&id=283baad9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports